export const FiltersDrawer = (function($){
    const bindEvents = () => {
        $(document)
            .on('click', '[data-filters-drawer-trigger]', toggleDrawer)
    }

    const toggleDrawer = (e) => {
        const $drawer = $(e.target).closest('[data-filters-drawer]');
        const isOpen = $drawer.hasClass('--is-active');
        const $products = document.querySelector('.shop-content');

        $('body').toggleClass('body-scroll-locked');
        $drawer.toggleClass('--is-active');

        if (isOpen && $products) {
            const top = $products.getBoundingClientRect().top + window.scrollY - 120;
            window.scrollTo({ top });
        }
    }

    return {
        init() { bindEvents(); }
    };
})(jQuery);